import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import {sync} from 'vuex-router-sync';

require('bulma/css/bulma.min.css');
require('@fortawesome/fontawesome-free/css/all.min.css');

Vue.config.productionTip = false;
sync(store, router);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
